import { render, staticRenderFns } from "./resetButton.vue?vue&type=template&id=32845b60&scoped=true&"
import script from "./resetButton.vue?vue&type=script&lang=js&"
export * from "./resetButton.vue?vue&type=script&lang=js&"
import style0 from "./resetButton.vue?vue&type=style&index=0&id=32845b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32845b60",
  null
  
)

export default component.exports